// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  height: 100%;
}

.style-block {
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.header-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 0px;
  align-items: center;
}
.header-wrapper .back_btn {
  width: 20px;
  height: 20px;
}
.header-wrapper h3 {
  text-align: center;
}
.header-wrapper .add_fav_btn {
  width: 40px;
  height: 40px;
  background: white;
  border-radius: 50%;
  box-shadow: 0px 0px 20px 0px rgba(79, 97, 79, 0.1490196078);
  display: flex;
  align-items: center;
  justify-content: center;
}
.header-wrapper .add_fav_btn.no-shadow {
  box-shadow: none;
}
.header-wrapper .add_fav_btn ion-icon {
  width: 25px;
  height: 25px;
}

.grow {
  flex-grow: 1;
  overflow: auto;
}

.back-img {
  position: absolute;
  top: 30px;
  left: 30px;
}

.image-wrapper {
  position: relative;
}
.image-wrapper .back_icon {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 99;
  zoom: 1.5;
}
.image-wrapper .cross_icon {
  z-index: 99;
  position: absolute;
  right: 10px;
  top: 10px;
  zoom: 1.5;
}

.main-img {
  height: 25vh;
  width: 100%;
  margin: 0 auto 0px;
}

.default-img {
  height: 25vh;
  width: 100px !important;
}

.info {
  padding: 20px 20px 0px 20px;
}
.info .title {
  text-align: left;
  font-size: 25px;
  line-height: var(--modal-info-title-line-height);
  margin-bottom: 6px;
  padding-top: 10px;
  color: var(--ion-color-secondary);
}
.info .title .info_block {
  font-size: 17px;
  margin-left: 5px;
  cursor: pointer;
}
.info .desc {
  text-align: left;
  font-size: var(--modal-info-desc-font-size);
  font-family: AppFont, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-secondary);
}
.info .ingrediants-section {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0px;
  align-items: center;
  width: 100%;
}
.info .ingrediants-section h3 {
  text-align: left;
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-secondary);
}
.info .ingrediants-section p {
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-primary);
  text-decoration: underline;
}
@media (max-width: 992px) {
  .info .ingrediants-section p {
    width: 50%;
    text-align: right;
  }
}

.usign-block {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 0px;
}
.usign-block .using-item {
  width: 100%;
  display: flex;
  padding: 7px 10px;
  box-shadow: 0px 0px 20px 0px rgba(79, 97, 79, 0.1490196078);
  border-radius: 16px;
  margin-bottom: 10px;
  align-items: center;
}
.usign-block .using-item ion-icon {
  width: 15%;
}
.usign-block .using-item .type-icon {
  width: 45px;
  height: 45px;
  margin-right: 10px;
}
.usign-block .using-item .next-icon {
  width: 30px;
  height: 30px;
  margin-left: 10px;
}
.usign-block .using-item .text-block {
  width: 70%;
}
.usign-block .using-item .text-block h3, .usign-block .using-item .text-block p {
  color: var(--ion-color-secondary);
  text-transform: inherit;
}
.usign-block .using-item .text-block h3 {
  font-size: 16px;
}
.usign-block .using-item .text-block p {
  font-size: 13px;
}

.info-text {
  text-align: center;
  padding: 5px 20px 20px;
  color: #C1C1C1;
  font-size: 12px;
}

.remove_btn {
  width: 100%;
  --background: var(--ion-color-danger);
}

.description {
  color: #899589;
  padding: 5px 0px;
  font-size: 16px !important;
}

.all-promo {
  display: flex;
  flex-direction: column;
}

.remove_btn {
  width: 100%;
  --background: var(--ion-color-danger);
  --color: white !important;
}
.remove_btn.add-btn {
  --background: var(--ion-color-primary) !important;
  --color: white !important;
}

.min-block {
  min-height: 70px;
  padding: 20px;
}

.all-promo {
  height: calc(100% - 270px);
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/coupon-item-show-modal/coupon-item-show-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;EACE,YAAA;AAAF;;AAEA;EACI,YAAA;EACA,gBAAA;EACF,aAAA;EACA,sBAAA;EACA,WAAA;AACF;;AACE;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,mBAAA;AAEJ;AADI;EACE,WAAA;EACA,YAAA;AAGN;AADI;EACE,kBAAA;AAGN;AADI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2DAAA;EAIA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAN;AALM;EACE,gBAAA;AAOR;AAFM;EACE,WAAA;EACA,YAAA;AAIR;;AAAE;EACE,YAAA;EACA,cAAA;AAGJ;;AAAE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AAGJ;;AADE;EAEE,kBAAA;AAGJ;AAFI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;AAIN;AAFI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AAIN;;AADE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAIJ;;AACE;EACE,YAAA;EACA,uBAAA;AAEJ;;AAAE;EAEE,2BAAA;AAEJ;AADI;EACE,gBAAA;EACA,eAAA;EACA,gDAAA;EACA,kBAAA;EACA,iBAAA;EACA,iCAAA;AAGN;AAFM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAIR;AAAI;EACE,gBAAA;EACA,2CAAA;EACA,gCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,iCAAA;AACN;AACI;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AACN;AAAM;EACE,gBAAA;EACA,eAAA;EACA,oCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,iCAAA;AACR;AACM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,+BAAA;EACA,0BAAA;AAAR;AC7HE;EDoHI;IAWI,UAAA;IACA,iBAAA;EAER;AACF;;AAGE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AAAJ;AACI;EACI,WAAA;EACA,aAAA;EACA,iBAAA;EACA,2DAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AACR;AAAQ;EACI,UAAA;AAEZ;AAAQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAEZ;AAAQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAEV;AAAQ;EACI,UAAA;AAEZ;AADY;EACE,iCAAA;EACA,uBAAA;AAGd;AADY;EACE,eAAA;AAGd;AADY;EACE,eAAA;AAGd;;AAGE;EACE,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;AAAJ;;AAEE;EACE,WAAA;EACA,qCAAA;AACJ;;AACE;EACE,cAAA;EACA,gBAAA;EACA,0BAAA;AAEJ;;AAAE;EACE,aAAA;EACA,sBAAA;AAGJ;;AADE;EACE,WAAA;EAEA,qCAAA;EACA,yBAAA;AAGJ;AAFI;EACE,iDAAA;EACA,yBAAA;AAIN;;AAAE;EACE,gBAAA;EACA,aAAA;AAGJ;;AADE;EACE,0BAAA;EACA,cAAA;AAIJ","sourcesContent":["@import \"../../../theme/mixins\";\n.wrapper {\n  height: 100%;\n}\n.style-block {\n    height: 100%;\n    overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  }\n  .header-wrapper {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    padding: 20px 20px 0px;\n    align-items: center;\n    .back_btn {\n      width: 20px;\n      height: 20px;\n    }\n    h3 {\n      text-align: center;\n    }\n    .add_fav_btn {\n      width: 40px;\n      height: 40px;\n      background: white;\n      border-radius: 50%;\n      box-shadow: 0px 0px 20px 0px #4F614F26;\n      &.no-shadow {\n        box-shadow: none;\n      }\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      ion-icon {\n        width: 25px;\n        height: 25px;\n      }\n    }\n  }\n  .grow {\n    flex-grow: 1;\n    overflow: auto;\n  }\n  \n  .back-img {\n    position: absolute;\n    top: 30px;\n    left: 30px;\n  }\n  .image-wrapper {\n    // background: black url('../../../assets/losteria/modal-info.png') no-repeat center center / 100% 100%;\n    position: relative;\n    .back_icon {\n      position: absolute;\n      left: 10px;\n      top: 10px;\n      z-index: 99;\n      zoom: 1.5;\n    }\n    .cross_icon {\n      z-index: 99;\n      position: absolute;\n      right: 10px;\n      top: 10px;\n      zoom: 1.5;\n    }\n  }\n  .main-img {\n    height: 25vh;\n    width: 100%;\n    margin: 0 auto 0px;\n    // &.full-width {\n    //   object-fit: cover;\n    // }\n  }\n  .default-img {\n    height: 25vh;\n    width: 100px !important;\n  }\n  .info {\n  \n    padding: 20px 20px 0px 20px;\n    .title {\n      text-align: left;\n      font-size: 25px;\n      line-height: var(--modal-info-title-line-height);\n      margin-bottom: 6px;\n      padding-top: 10px;\n      color: var(--ion-color-secondary)    ;\n      .info_block {\n        font-size: 17px;\n        margin-left: 5px;\n        cursor: pointer;\n      }\n    }\n  \n    .desc {\n      text-align: left;\n      font-size: var(--modal-info-desc-font-size);\n      font-family: AppFont, sans-serif;\n  \n      line-height: var(--modal-info-desc-line-height);\n      padding-bottom: 10px;\n      color: var(--ion-color-secondary);\n    }\n    .ingrediants-section {\n      display: flex;\n      justify-content: flex-end;\n      padding: 10px 0px;\n      align-items: center;\n      width: 100%;\n      h3 {\n        text-align: left;\n        font-size: 18px;\n        font-family: AppFontBold, sans-serif;\n    \n        line-height: var(--modal-info-desc-line-height);\n        padding-bottom: 10px;\n        color: var(--ion-color-secondary);\n      }\n      p {\n        cursor: pointer;\n        text-align: left;\n        font-size: 16px;\n        font-family: AppFontBold, sans-serif;\n    \n        line-height: var(--modal-info-desc-line-height);\n        padding-bottom: 10px;\n        color:var(--ion-color-primary);\n        text-decoration: underline;\n        @include mobile {\n          width: 50%;\n          text-align: right;\n        }\n  \n      }\n    }\n  }\n  .usign-block {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 10px 0px;\n    .using-item {\n        width: 100%;\n        display: flex;\n        padding: 7px 10px;\n        box-shadow: 0px 0px 20px 0px #4F614F26;\n        border-radius: 16px;\n        margin-bottom: 10px;\n        align-items: center;\n        ion-icon  {\n            width: 15%;\n        }\n        .type-icon {\n            width: 45px;\n            height: 45px;\n            margin-right: 10px;\n        }\n        .next-icon {\n          width: 30px;\n          height: 30px;\n          margin-left: 10px;\n        }\n        .text-block {\n            width: 70%;\n            h3,p {\n              color: var(--ion-color-secondary);\n              text-transform: inherit;\n            }\n            h3 {\n              font-size: 16px;\n            }\n            p {\n              font-size: 13px;\n            }\n        }\n    }\n   \n  }\n  .info-text {\n    text-align: center;\n    padding: 5px 20px 20px;\n    color: #C1C1C1;\n    font-size: 12px;\n  }\n  .remove_btn {\n    width: 100%;\n    --background: var(--ion-color-danger);\n  }\n  .description {\n    color: #899589;\n    padding: 5px 0px;\n    font-size: 16px !important;\n  }\n  .all-promo {\n    display: flex;\n    flex-direction: column;\n  }\n  .remove_btn {\n    width: 100%;\n\n    --background: var(--ion-color-danger);\n    --color: white !important;\n    &.add-btn {\n      --background: var(--ion-color-primary) !important;\n      --color: white !important;\n\n    }\n  }\n  .min-block {\n    min-height: 70px;\n    padding: 20px;\n  }\n  .all-promo {\n    height: calc(100% - 270px);\n    overflow: auto;\n  }","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
